module.exports = __webpack_public_path__ + "static/fonts/notokr-medium.6a273c1.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/a7070-glister/font/notokr-medium.woff2
// module id = NsDV
// module chunks = 0